import TopRatingAgencies from './TopRatingAgencies';

export default TopRatingAgencies;
